function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M43.06 83.962h84.533L143.517 35.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M175.92 20h82.993l16.953 48.362z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M143.517 35.6v48.362h-15.924z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M143.517 35.6l73.892 77.18.007-72.696z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M175.92 20h82.993L217.416 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M143.517 35.6l73.899 4.495L175.919 20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M143.517 35.6v141.87l73.892-64.69zM43.06 83.962l70.159 69.422 30.298-69.422z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M143.517 83.962v159.231l-30.298-89.81zM113.219 153.384L43.06 83.962 27.21 153.384z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M143.517 243.193L217.41 112.78l-73.892 64.69z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M113.219 153.384l-19.93 42.443 50.228 47.366z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M93.289 195.827L11.32 223l15.89-69.616z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M27.21 153.384l66.079 42.443 19.93-42.443z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M0 272.622l93.289-76.795L11.32 223z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4FF",
  d: "M217.416 112.78l58.45-44.418-58.45-28.278zM275.866 68.362l65.615-8.636L258.913 20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M217.409 112.78l58.457 37.942 65.615-90.996-65.615 8.636z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2C60C8",
  d: "M209.692 196.959l66.174-46.237-58.457-37.942z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M189.455 211.078l-8.988 77.13 95.399-83.185-46.366-21.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M180.463 288.208l-36.946 42.247-92.073-68.375 92.073-18.887zM0 272.622l51.444-10.542-5.336 68.375z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M46.108 330.455h97.41L86.398 288.03z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M51.444 262.08l-5.336 68.375 40.291-42.425z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#234A96",
  d: "M96.057 330.455H46.108l25.354 31.775z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M86.4 362.23h29.553l27.564-31.775h-47.46z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M71.462 362.23h14.937l9.658-31.775z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M115.953 362.23l4.7 61.686-49.191-61.686z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M115.953 362.23h64.514v-74.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#234A96",
  d: "M180.467 362.23h-64.514l4.7 61.686z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M275.866 150.722v54.301l69.135-54.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M275.866 150.722h131.13l-15.239-66.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M275.866 205.023l34.567 33.802 34.568-88.103z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M180.467 288.208l129.966-49.383-34.567-33.802z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M310.433 238.825l92.28-40.536 4.283-47.567h-61.995z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M402.713 198.289l4.283-47.567 10.867 47.567z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M402.713 198.289l-22.124 40.536 47.528 4.35-10.254-44.886z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M380.59 238.825h-70.157l92.28-40.536z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M345.001 238.825l-61.862 57.442-102.672-8.059 129.966-49.383z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M283.14 296.267l97.45-57.442H345z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M180.467 362.23l54.945-69.706-54.945-4.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M231.803 330.455l51.336-34.188-47.727-3.743z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M231.803 330.455l3.61-37.931-54.946 69.706z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M380.59 238.825l22.123 47.999 32.105-14.202-6.7-29.447z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M402.713 286.824l32.105-14.202-32.105 40.276z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M402.713 312.898l-57.712-53.064 35.588-21.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M380.59 238.825l22.123 47.999v26.074z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M283.14 296.267l119.573 16.631-57.712-53.064z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M283.14 296.267l48.724 37.81v-31.034z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M331.864 334.078h53.941l16.908-21.18-70.849-9.855z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M331.864 334.078h53.941l-26.97 33.827z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M331.864 334.078v67.686l26.97-33.859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D52BB",
  d: "M180.467 362.23l-13.354 61.686h-46.46z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M180.463 362.23h70.699l40.116-28.152h-65.313z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M291.278 334.078l-27.854-24.665-37.459 24.665z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M291.278 334.078l-8.139-37.811-19.715 13.146z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#234A96",
  d: "M331.864 334.078h-40.586l-8.139-37.811z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M167.113 423.916l84.049-61.686h-70.695z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M167.113 423.916h58.852l-8.556-36.873z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#326DE6",
  d: "M314.165 423.916l17.7-89.838v67.686z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M331.864 334.078h-40.586l22.887 89.838z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D4493",
  d: "M314.165 423.916l-63.003-61.686 40.116-28.152zM251.162 362.23l-25.197 61.686-8.556-36.873z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12357C",
  d: "M225.965 423.916h88.2l-37.648-36.873z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M225.965 423.916l25.197-61.686 25.355 24.813z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M229.5 183.103l46.366-32.38v54.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M143.517 243.175l66.175-46.216-21.258-32.963z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79A5FF",
  d: "M188.434 163.996l21.258 32.963 7.724-84.18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D55A5",
  d: "M275.866 150.722l65.565-90.941 15.067 44.46z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5489F3",
  d: "M356.498 104.241l35.26-20.28-50.277-24.18zM180.467 288.03l8.988-76.952-45.938 32.115z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2C60C8",
  d: "M0 272.622l93.289-76.795 50.228 47.366z"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.858,
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M201.434 6.221l.927.375-19.397 48.02a5.021 5.021 0 011.972 2.192l75.738-37.847.447.895-75.856 37.905a5.014 5.014 0 01.103 1.693l134.096 8.636a4.995 4.995 0 011.775-3.058L306.48 42.684l.835-.551 14.758 22.347a4.967 4.967 0 011.825-.547v-12.87h1v12.87a5.004 5.004 0 014.31 3.608l23.102-4.125.175.985-23.102 4.126a4.98 4.98 0 01-1.142 3.58l49.027 49.902a4.979 4.979 0 013.13-1.1c.542 0 1.064.086 1.553.246l11.496-28.57.928.373-11.509 28.601a4.998 4.998 0 012.53 4.454l17.369 2.192-.126.992-17.362-2.191a4.996 4.996 0 01-1.535 2.62l28.505 41.437-.824.567-28.488-41.412a4.97 4.97 0 01-1.262.526l15.438 97.173a5 5 0 015.262 4.492h23.214v1h-23.214a5.004 5.004 0 01-3.116 4.142l17.08 59.219-.96.277-17.08-59.22a5.03 5.03 0 01-2.277-.11L354.703 341.47a5.02 5.02 0 012.246 2.365l28.684-9.726.321.947-28.684 9.726a5.016 5.016 0 01-.69 3.865l11.012 8.902-.629.777-11.011-8.902a4.985 4.985 0 01-3.054 1.459v26.328h-1v-26.328a4.998 4.998 0 01-3.642-2.173l-51.13 23.569c.176.51.272 1.058.272 1.628 0 1.343-.53 2.561-1.39 3.46l28.77 33.695-.76.649-28.77-33.695a4.972 4.972 0 01-2.463.877l-1.019 44.942-1-.023 1.019-44.942a4.993 4.993 0 01-3.248-1.785l-70.77 47.238-.556-.831 70.77-47.238a4.965 4.965 0 01-.487-1.362l-173.096 17.025a4.98 4.98 0 01-1.206 3.246l27.068 28.4-.724.69-27.068-28.399a4.978 4.978 0 01-3.07 1.053h.043l-1.354 12.594-.994-.107 1.353-12.577a5.003 5.003 0 01-4.024-4.409h-9.62v-1h9.62a5.002 5.002 0 012.563-3.881L40.89 232.682a4.998 4.998 0 01-1.493.226 4.981 4.981 0 01-3.34-1.279L2.336 262.358l-.674-.74 33.72-30.728a4.978 4.978 0 01-.928-3.743l-23.272-6.023.25-.968 23.272 6.022a5.012 5.012 0 013.349-3.087l-11.879-68.538.985-.171 11.88 68.539a4.981 4.981 0 012.448.445l54.956-93.423a5 5 0 01-1.964-3.125l-62.352 5.174-.083-.997 62.353-5.175a4.988 4.988 0 011.725-3.69L62.49 74.385l.818-.576 33.632 47.743a4.977 4.977 0 012.852-.63l12.923-71.391.984.178-12.923 71.39c.827.237 1.566.681 2.157 1.273l73.66-60.22a4.98 4.98 0 01-1.195-3.245c0-1.171.402-2.248 1.077-3.1l-21.96-26.077.765-.645 21.895 26a4.98 4.98 0 013.223-1.178c.582 0 1.14.1 1.66.283l19.376-47.97zm4.363 332.066a4.999 4.999 0 01-8.364.669l-83.214 51.623c.031.113.058.228.082.344l173.097-17.026a5 5 0 01.215-1.445zm-78.173-38.706a4.996 4.996 0 01-4.45 2.323l-12.414 85.192a5.013 5.013 0 013.089 2.533l83.056-51.523a4.98 4.98 0 01-.507-2.198c0-.626.115-1.225.325-1.777zm-84.7-68.128c-.329.327-.703.61-1.113.835l66.093 154.847a4.998 4.998 0 011.871-.213l12.41-85.162a5.002 5.002 0 01-2.95-7.622zm196.323-3.678l-35.602 103.151-.152.441a5.002 5.002 0 012.9 4.325l.005.216a5 5 0 01-.216 1.457L288 371.529a5.02 5.02 0 012.304-2.162l-48.759-141.59a5.014 5.014 0 01-2.297-.002zm81.606 63.918a5 5 0 01-2.112.173l-24.373 77.446a5.02 5.02 0 012.339 2.06l51.072-23.544a4.985 4.985 0 01-.381-1.92c0-1.622.773-3.065 1.971-3.978zm-77.711-64.604a4.99 4.99 0 01-.652.362l48.76 141.59a5.014 5.014 0 012.164-.03l24.352-77.375a5.002 5.002 0 01-2.578-7.427zm90.853-17.197l-13.21 72.211a5.002 5.002 0 01.997 9.201l28.44 50.102a4.964 4.964 0 011.003-.36l-16.819-131.138c-.144 0-.278-.005-.411-.016zm4.25-1.79a4.997 4.997 0 01-2.843 1.706l16.814 131.103.182-.003c.477 0 .939.067 1.376.192l41.317-103.754a5 5 0 01-2.464-5.939zm-101.757 17.924l-108.203 69.823a5.02 5.02 0 01-.213 2.837l69.099 34.55a4.996 4.996 0 015.377-2.195l.021-.06 10.035-29.078L238.3 227.45a5.018 5.018 0 01-1.812-1.423zm-68.74-34.65a4.998 4.998 0 01-5.622 2.37l-36.755 98.567a5.018 5.018 0 012.592 2.554l107.982-69.68a4.979 4.979 0 01-.547-2.279c0-.542.086-1.064.246-1.553zM97.304 130.45L42.35 223.873a4.993 4.993 0 012.048 4.035c0 1.026-.31 1.98-.839 2.773l76.31 62.684a4.993 4.993 0 012.341-1.315L99.592 130.904l-.194.004a4.981 4.981 0 01-2.094-.458zm5.312-.715a4.985 4.985 0 01-2.031 1.032L123.2 291.912l.198-.004c.349 0 .69.036 1.018.104l36.773-98.616a5 5 0 01-1.321-8.029zm226.995 76.622l-84.233 16.108a4.984 4.984 0 01-1.443 3.977l71.876 56.983a4.985 4.985 0 013.99-1.5l13.209-72.212a5.01 5.01 0 01-3.4-3.356zm48.85-75.837l-41.11 70.353a4.993 4.993 0 012.047 4.035c0 .85-.212 1.648-.585 2.348l54.208 23.233a5.01 5.01 0 013.101-2.416L380.684 130.9a4.985 4.985 0 01-2.222-.38zm-110.168-.535a4.977 4.977 0 01-3.654.866l-22.516 87.363a5.013 5.013 0 013.068 3.267l84.228-16.107a4.982 4.982 0 011.32-3.873zm-6.865-1.036l-93.534 57.77a4.98 4.98 0 01.504 2.19c0 .541-.087 1.063-.246 1.552l67.896 29.98a4.998 4.998 0 015.107-2.475l22.516-87.364a5.013 5.013 0 01-2.243-1.653zm113.994-2.54h-105.05a4.982 4.982 0 01-1.326 2.918l62.443 71.514a4.977 4.977 0 012.909-.933c.746 0 1.453.164 2.09.457l41.095-70.323a4.997 4.997 0 01-2.16-3.634zM184.018 62.356a4.986 4.986 0 01-3.719 1.55L164.54 184.04a5.002 5.002 0 012.827 1.828l93.534-57.771a4.98 4.98 0 01-.503-2.189c0-.989.287-1.911.783-2.688zm-6.696.494l-73.756 60.295c.525.791.832 1.741.832 2.762a4.979 4.979 0 01-1.084 3.109l57.335 55.714a4.977 4.977 0 012.9-.82l15.758-120.122a4.98 4.98 0 01-1.985-.938zm143.845 9.874l-51.844 50.086a4.976 4.976 0 011.05 2.598h105.05a4.978 4.978 0 011.131-2.699l-49.027-49.902a4.979 4.979 0 01-3.13 1.1 4.98 4.98 0 01-3.23-1.183zm-136.01-12.282c-.128.4-.305.777-.525 1.125l77.169 60.867a4.985 4.985 0 013.597-1.527 4.98 4.98 0 013.23 1.184l51.843-50.087a4.979 4.979 0 01-1.073-3.097l.002.178z"
})));

var SvgMobileLogo = function SvgMobileLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 435 425"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/mobile-logo.34017dee.svg";
export { SvgMobileLogo as ReactComponent };